<script setup>
// O ícone à esquerda de cada tool nas listas: a aba Ferramentas do agente e o catálogo do "Adicionar
// ferramenta". Blocos ligados para flow, chave para tool comum (declarada, nativa, de template ou de
// legado). É o ícone que diz que é flow, no lugar da etiqueta "Flow" que saiu (Murilo, 16/10): o
// quadrado é neutro e só o ícone tem cor, porque etiqueta colorida não se usa no OS.
//
// FLOW-13 (mockup aprovado, decisão 5): a ferramenta HTTP leva o globo do nó HTTP do canvas, em
// laranja, no mesmo quadrado neutro. O `pequeno` é o da lista do "Usado por" (24 px).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  flow: { type: Boolean, default: false },
  http: { type: Boolean, default: false },
  pequeno: { type: Boolean, default: false },
});

const { t } = useI18n();

const tipo = computed(() => {
  if (props.http) return 'http';
  return props.flow ? 'flow' : 'tool';
});

const rotulo = computed(() => {
  if (tipo.value === 'http') return t('POWER_AGENTS.TOOLS.KIND_HTTP');
  return tipo.value === 'flow'
    ? t('POWER_AGENTS.TOOLS.KIND_FLOW')
    : t('POWER_AGENTS.TOOLS.KIND_TOOL');
});

const GLIFOS = {
  http: 'i-lucide-globe text-n-orange-11',
  flow: 'i-lucide-workflow text-n-violet-11',
  tool: 'i-lucide-wrench text-n-slate-11',
};
</script>

<template>
  <span
    role="img"
    data-icone-da-tool
    :data-tipo="tipo"
    :aria-label="rotulo"
    class="grid shrink-0 place-items-center border border-n-weak bg-n-alpha-2"
    :class="pequeno ? 'size-6 rounded-md' : 'size-[30px] rounded-[7px]'"
  >
    <span
      :class="[GLIFOS[tipo], pequeno ? 'size-3.5' : 'size-4']"
      aria-hidden="true"
    />
  </span>
</template>
